export default __webpack_public_path__ + "static/media/joel-muniz.43d6adb8.jpg";